import { render } from "./Quiz.vue?vue&type=template&id=4bbafd26&scoped=true&ts=true"
import script from "./Quiz.vue?vue&type=script&lang=ts"
export * from "./Quiz.vue?vue&type=script&lang=ts"

import _style_0 from "./Quiz.vue?vue&type=style&index=0&id=4bbafd26&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-4bbafd26"]])

export default __exports__